import { API } from '../api';
import { IConfirmMatchRequest, IDatingProfileModel, ISendMatchRequest } from '../models/dating.model';
import { IDataResponse } from '../types/common';

const endPoint = {
  datingProfile: 'v1/user-service/datings/user-dating-profile',
  userDatingProfiles: 'v1/user-service/datings/user-dating-profiles/filtered',
  updateDatingProfile: 'v1/user-service/datings/create-or-update-dating-profile',
  sendMatchRequest: 'v1/user-service/datings/send-match-request',
  matchRequestsByProfileId: 'v1/user-service/datings/match-requests-by-profile-id',
  confirmMatchRequest: 'v1/user-service/datings/is-confirm-match-request',
  datingInfo: '/v1/user-service/datings/dating-profile-stats',
  connected: 'v1/user-service/datings/matched-dating-profiles',
  matchProfile: '/v1/user-service/datings/user-dating-profile-by-profile-id/',
  sendConnected: '/v1/user-service/datings/get-sent-match-requests',
  unmatchProfile: 'v1/user-service/datings/unmatch-profile',
  unMatchSentRequest: '/v1/user-service/datings/unsend-match-request',
  getFriendsDating: '/v1/user-service/datings/matched-profiles-with-status',
};

export const datingService = {
  async getDatingProfile() {
    const { data } = await API.get<IDatingProfileModel>(endPoint.datingProfile);
    return data;
  },
  async getUserDatingProfiles(payload: any) {
    const { data } = await API.post<IDatingProfileModel[]>(endPoint.userDatingProfiles, payload);
    return data;
  },
  async updateDatingProfile(payload: IDatingProfileModel) {
    const { data } = await API.post<IDataResponse<IDatingProfileModel>>(endPoint.updateDatingProfile, payload);
    return data;
  },
  async sendMatchRequest(payload: ISendMatchRequest) {
    const { data } = await API.post<IDataResponse<any>>(endPoint.sendMatchRequest, payload);
    return data;
  },
  async getMatchRequestsByProfileId(profileId: string) {
    const { data } = await API.get<IDataResponse<any>>(endPoint.matchRequestsByProfileId, {
      params: { uuid: profileId },
    });
    return data;
  },
  async confirmMatchRequest(payload: IConfirmMatchRequest) {
    const { data } = await API.post<IDataResponse<any>>(endPoint.confirmMatchRequest, payload);
    return data;
  },
  async getDatingInfoByProfileId(profileId: string) {
    const { data } = await API.get<IDataResponse<any>>(endPoint.datingInfo, {
      params: { profileId },
    });
    return data;
  },

  async getConnected() {
    const { data } = await API.get<IDataResponse<any>>(endPoint.connected, {});
    return data;
  },

  async getProfileMatch(profileId) {
    const { data } = await API.get<IDataResponse<IDatingProfileModel>>(`${endPoint.matchProfile}${profileId}`);
    return data;
  },

  async getSendConnected(profileId) {
    const { data } = await API.get<IDataResponse<any>>(endPoint.sendConnected,{
      params: { uuid: profileId },
    });
    return data;
  },

  async unMatchProfile(profile: string, unmatchProfileId: string) {
    const { data } = await API.put<IDataResponse<any>>(endPoint.unmatchProfile, {profileId: profile, unmatchProfileId});
    return data;
  },

  async unMatchSentRequest(profile: string, unmatchProfileId: string) {
    const { data } = await API.delete(endPoint.unMatchSentRequest, {
      data: { profileId: profile, unsendProfileId: unmatchProfileId },
    });
    return data;
  },

  async getFriendsDating(profileId: string, pageNumber: number, pageSize: number,) {
    const { data } = await API.post<any>(endPoint.getFriendsDating, {
      profileId,
      pageSize,
      pageNumber
    });
    return data?.data;
  },
};
